import {
    calculatePolygonCenter,
    isGeometryWithCoordinates,
} from '../../../../utils/MapUtils'
import { IEntityTableDefinition } from '../../../Entity/interfaces'
import { IPosition, ISite } from '../interfaces'

const LOCATION_ATTRIBUTE_ID = 'location'

export const getLocationDetails = (
    value: unknown,
): { position: IPosition; address: string } | null => {
    let location: GeoJSON.Feature | undefined
    try {
        const geoJSON = value as GeoJSON.FeatureCollection
        location = geoJSON?.features?.[0]
    } catch {
        return null
    }

    if (!location || !isGeometryWithCoordinates(location.geometry)) {
        return null
    }

    let position: IPosition
    if (location.geometry.type === 'Point') {
        position = {
            lat: location.geometry.coordinates[1],
            lng: location.geometry.coordinates[0],
        }
    } else if (location.geometry.type === 'Polygon') {
        const polygonCenter = calculatePolygonCenter(
            location.geometry.coordinates[0],
        )
        position = {
            lat: polygonCenter[1],
            lng: polygonCenter[0],
        }
    } else {
        return null
    }

    return {
        position,
        address: location?.properties?.address || '',
    }
}

export const prepareSiteList = (
    siteRecords: IEntityTableDefinition,
    siteLocationAttributeId: string,
    siteNameAttributeId: string,
): ISite[] => {
    const siteList: ISite[] =
        siteRecords?.data?.reduce((acc: ISite[], record) => {
            const location = getLocationDetails(
                record.attributes?.[LOCATION_ATTRIBUTE_ID] || {},
            )
            if (!location) {
                return acc
            }

            const siteAddress = location.address || 'Unknown Site'
            const siteName =
                record.attributes?.[siteNameAttributeId] ||
                siteAddress ||
                'Unknown Site'

            acc.push({
                id: record.entityId,
                position: location.position,
                siteAddress,
                siteName,
                permissionLevel: record.action,
                uid: record.uid,
            })
            return acc
        }, []) ?? []

    return siteList
}
